module.exports = __webpack_public_path__ + "img/pic3.a95ba152.png";